module.exports = __webpack_public_path__ + "static/media/lazare.0c1db758.png";